import React from 'react';
const SvgDownload = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 32 32", focusable: false }, props),
    React.createElement("path", { d: "M0 27.996h32V32H0v-4.004zm22.36-13.983l2.83 2.823L16 26.044l-9.19-9.208 2.83-2.823L14 18.377V0h4v18.377l4.36-4.364z" })));
export default SvgDownload;
//# sourceMappingURL=Download.js.map